import { z } from "zod";
import { COLORS } from "../../colors";
import { sizeUnits } from "../../units";

export const dimensionValuesFormSchema = z.object({
	unit: z.enum(sizeUnits),
	text: z.string().optional(),
	color: z.enum(COLORS),
	markerColor: z.enum(COLORS),
});

export type DimensionValuesFormSchema = z.infer<typeof dimensionValuesFormSchema>;
